document.addEventListener("alpine:init", () => {
    Alpine.data("postShare", () => ({
        sharePost: false,
        copied: false,
        init() {},
        copyToClipboard(url) {
            navigator.clipboard.writeText(url).then(
                () => {
                    this.copied = true;
                    setTimeout(() => (this.copied = false), 2000);
                },
                () => {
                    console.error("Failed to copy to clipboard");
                }
            );
        },
    }));
});

document.addEventListener("alpine:init", () => {
    Alpine.data("postBanner", () => ({
        scrollToContent() {
            const contentSection = document.querySelector(".Post__Content");
            const header = document.querySelector(".Navigation__bar");
            const headerHeight = header ? header.offsetHeight*2 : 0;
            if (contentSection) {
                pegasus.scroll(contentSection, -headerHeight, "scrollTo");
            }
        },
    }));
});
